import { useEffect, useState } from "react";
import { onSnapshot, where } from "firebase/firestore";
import { orgQuery } from "@/lib/org";
import type { DongClaim } from "@/types";

export function useDongClaims(yearMonth: string) {
  const [claims, setClaims] = useState<DongClaim[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const q = orgQuery("dongClaims", where("yearMonth", "==", yearMonth));
    const unsub = onSnapshot(q, (snap) => {
      setClaims(snap.docs.map((d) => ({ id: d.id, ...(d.data() as any) })));
      setLoading(false);
    });
    return () => unsub();
  }, [yearMonth]);

  return { claims, loading };
}
